<div class="row container-header container-responsive">
  <div class="col-md-12 col-lg-6 mb-4 mb-md-0">
    <h3 class="font-weight-normal">Registro - <strong>Cliente Enex Express+</strong></h3>
  </div>
</div>
<div class="col-12">

  <div class="row mt-4">

    <div class="col-1 d-md-block d-none"></div>
    

    <div class="col-12">
      <p>Enex Express + es nuestro servicio de diésel a domicilio entre 200 y 1.000 litros sin requisitos financieros previos.</p>
    </div>


    <div class="col-12 col-md-10 card-msg mb-4" style="background-color: rgb(173, 174, 176, 0.2);">


      <div class="row">
        <div class="col-12">
          <h4 class="text-dark">Comunas disponibles</h4>

          <p>El servicio Enex Express+ solo está disponible en las siguientes comunas:</p>
        </div>

        <div class="col-12">
          <div class="row">
           
            <div class="col-12 col-md-3 text-dark" *ngFor="let comuna of comunas">
              {{ comuna.comuna }}
            </div>

          </div>
        </div>

        <div class="col-12 mt-3">

          
          <p>Nuestro servicio pronto estará disponible en nuevas comunas</p>
        </div>
      </div>

    </div>
  </div>
</div>